import { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Modal, SelectPicker, DatePicker } from "rsuite";
import { selector } from "../../../api";
import { Divider, InputNumber } from "antd";
import { useNotification } from "../../../utils/notificationProvider";
import { appCRUD } from "../../../actions/app";
import { char } from "../../../utils";

const examSchema = Yup.object().shape({
  campus: Yup.string().required("This field is required"),
  exam_start_date: Yup.date().required("Start date is required"),
  exam_end_date: Yup.date().required("End date is required"),
});

const initialValues = {
  campus: "",
  exam_start_date: null,
  exam_end_date: null,
  max_exams_per_day: 2,
  min_gap_between_exams: 1,
};

export const ExamTimetableAdd = (props) => {
  const { open, setOpen, index, setIndex } = props;
  const user = selector.User();
  const [loading, setLoading] = useState(false);
  const openNotification = useNotification();
  const [academic, setAcademic] = useState(null);
  const [, setAcademicId] = useState(null);
  const [semester, setSemester] = useState(null);
  const [campus, setCampus] = useState([]);
  const [searchCampus, setSearchCampus] = useState("");

  useEffect(() => {
    setTimeout(() => {
      appCRUD
        .loadCampas(50, 0, searchCampus, "name")
        .then((reps) => {
          setCampus(reps.data.results);
        })
        .catch(() => {});
    }, 500);
  }, [searchCampus]);

  useEffect(() => {
    setTimeout(() => {
      appCRUD
        .loadAcademicActive()
        .then((resp) => {
          if (resp.data && resp.data.length > 0) {
            setAcademic(resp.data[0].academic_id);
            setAcademicId(resp.data[0].id);
            appCRUD
              .loadSemisterActive(resp.data[0].id)
              .then((resp) => {
                if (resp.data && resp.data.length > 0) {
                  setSemester(resp.data[0].code);
                }
              })
              .catch(() => {});
          }
        })
        .catch(() => {});
    }, 500);
  }, []);

  const formik = useFormik({
    initialValues,
    validationSchema: examSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { campus, exam_start_date, exam_end_date, max_exams_per_day, min_gap_between_exams } = values;
      const recorded_by = user.id;

      const data = {
        campus,
        academicYear: parseInt(academic),
        semester: parseInt(semester),
        exam_start_date: exam_start_date ? exam_start_date.toISOString().split('T')[0] : null,
        exam_end_date: exam_end_date ? exam_end_date.toISOString().split('T')[0] : null,
        max_exams_per_day: max_exams_per_day || 2,
        min_gap_between_exams: min_gap_between_exams || 1,
        recorder: parseInt(recorded_by),
      };

      setLoading(true);
      setTimeout(() => {
        appCRUD
          .addExamTimetable(data)
          .then(() => {
            openNotification(
              "success",
              "Success",
              <>
                Exam timetable created successfully!
              </>
            );
            setIndex(index + 1);
            resetForm();
            setLoading(false);
            setSubmitting(false);
            setOpen(false);
          })
          .catch((error) => {
            setLoading(false);
            setSubmitting(false);
            openNotification(
              "error",
              "Error",
              <>
                {error.response?.data?.detail || "Something went wrong. Please try again."}
              </>
            );
          });
      }, 1000);
    },
  });

  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)} size="md">
        <Modal.Header>
          <Modal.Title>New Examination Timetable</Modal.Title>
        </Modal.Header>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-12 mb-3">
                  <div className="form-group">
                    <label className="text-body mb-2">
                      Campus <span className="text-danger">&nbsp;*</span>
                    </label>
                    <SelectPicker
                      className="w-100"
                      data={campus?.map((dt) => ({
                        value: dt.compas_id,
                        label: char.toTitleCase(dt.name),
                      }))}
                      placeholder="Select Campus"
                      onChange={(e) => formik.setFieldValue("campus", e)}
                      onClean={() => {
                        formik.setFieldValue("campus", "");
                      }}
                      onSearch={(e) => setSearchCampus(e)}
                    />
                    {formik.touched.campus && formik.errors.campus && (
                      <div className="fw-light mt-1" style={{ fontSize: "12px" }}>
                        <span role="alert" className="text-danger">
                          {formik.errors.campus}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <div className="form-group">
                    <label className="text-body mb-2">
                      Exam Start Date <span className="text-danger">&nbsp;*</span>
                    </label>
                    <DatePicker
                      className="w-100"
                      format="dd-MM-yyyy"
                      placeholder="Select Start Date"
                      onChange={(value) => formik.setFieldValue("exam_start_date", value)}
                      onClean={() => formik.setFieldValue("exam_start_date", null)}
                    />
                    {formik.touched.exam_start_date && formik.errors.exam_start_date && (
                      <div className="fw-light mt-1" style={{ fontSize: "12px" }}>
                        <span role="alert" className="text-danger">
                          {formik.errors.exam_start_date}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <div className="form-group">
                    <label className="text-body mb-2">
                      Exam End Date <span className="text-danger">&nbsp;*</span>
                    </label>
                    <DatePicker
                      className="w-100"
                      format="dd-MM-yyyy"
                      placeholder="Select End Date"
                      onChange={(value) => formik.setFieldValue("exam_end_date", value)}
                      onClean={() => formik.setFieldValue("exam_end_date", null)}
                    />
                    {formik.touched.exam_end_date && formik.errors.exam_end_date && (
                      <div className="fw-light mt-1" style={{ fontSize: "12px" }}>
                        <span role="alert" className="text-danger">
                          {formik.errors.exam_end_date}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <div className="form-group">
                    <label className="text-body mb-2">Max Exams Per Day</label>
                    <InputNumber
                      className="w-100"
                      min={1}
                      max={5}
                      value={formik.values.max_exams_per_day}
                      onChange={(value) => formik.setFieldValue("max_exams_per_day", value)}
                    />
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <div className="form-group">
                    <label className="text-body mb-2">Min Gap Between Exams (days)</label>
                    <InputNumber
                      className="w-100"
                      min={0}
                      max={7}
                      value={formik.values.min_gap_between_exams}
                      onChange={(value) => formik.setFieldValue("min_gap_between_exams", value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Divider style={{ marginTop: -10 }} />
          <Modal.Footer>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 d-flex justify-content-start">
                  <span className="fs-18 text-danger"> * &nbsp;</span> Required field
                </div>
                <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                  <button
                    onClick={() => setOpen(false)}
                    type="button"
                    className="btn btn-soft-danger me-3"
                  >
                    <i className="ri-close-circle-line align-middle fs-16 me-2"></i>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-soft-success"
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    {!loading && (
                      <span className="indicator-label">
                        <i className="ri-check-double-line align-middle fs-16 me-2"></i>
                        Save
                      </span>
                    )}
                    {loading && (
                      <span className="indicator-progress" style={{ display: "block" }}>
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
